module.exports = __webpack_public_path__ + "static/media/www.anniskeluravintolaruma.fi.5c130005.png";